import config from "@/config"
import http from "@/utils/request"
export default {
    PreCreate: {
        url: `${config.API_URL}/PCAliPay/PreCreate`,
        name: "当面付",
        post: async function (data) {
            return await http.post(this.url, data, {
                headers: {
                    //'response-status': 401
                }
            });
        }
    },
    Query: {
        url: `${config.API_URL}/PCAliPay/Query`,
        name: "交易查询",
        post: async function (data) {
            return await http.post(this.url, data, {
                headers: {
                    //'response-status': 401
                }
            });
        }
    },
    Refund: {
        url: `${config.API_URL}/PCAliPay/Refund`,
        name: "交易查询",
        post: async function (data) {
            return await http.post(this.url, data, {
                headers: {
                    //'response-status': 401
                }
            });
        }
    },
    RefundQuery: {
        url: `${config.API_URL}/PCAliPay/RefundQuery`,
        name: "交易查询",
        post: async function (data) {
            return await http.post(this.url, data, {
                headers: {
                    //'response-status': 401
                }
            });
        }
    },
    Close: {
        url: `${config.API_URL}/PCAliPay/Close`,
        name: "交易查询",
        post: async function (data) {
            return await http.post(this.url, data, {
                headers: {
                    //'response-status': 401
                }
            });
        }
    },
	CodePay: {
	    url: `${config.API_URL}/PCAliPay/CodePay`,
	    name: "交易查询",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	GetoutTradeNo:{
	    url: `${config.API_URL}/PayService/GetoutTradeNo`,
	    name: "交易查询",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	GetOutRequestNo:{
	    url: `${config.API_URL}/PayService/GetOutRequestNo`,
	    name: "交易查询",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	}
}
